import { connect } from 'react-redux';
import { setDialogDetails } from '../store/supplierAuthorizationSlice';
import { confirmCloseDialog } from '../store/createNewSupplierAuthSlice';

import ConfirmationDialog from './ConfirmationDialog';

const mapState = state => ({
  dialogDetails: state.loadingManagement.supplierAuthorizations.dialogDetails,
  supplierAuthorizationsError:
    state.loadingManagement.supplierAuthorizations.supplierAuthorizationsError,
});

const mapDispatch = (dispatch, ownProps) => {
  return {
    confirmCloseDialog: () =>
      ownProps.confirmCloseDialog
        ? dispatch(ownProps.confirmCloseDialog())
        : dispatch(confirmCloseDialog()),
    setDialogDetails: () => dispatch(setDialogDetails()),
  };
};

export default connect(mapState, mapDispatch)(ConfirmationDialog);
